import { FirebaseOptions } from 'firebase/app';

import { firebaseConfigs } from './firebase.config';

export interface Environment {
  production: boolean;
  firebase: FirebaseOptions;
  firestoreDatabaseId?: string;
  apiUrl: string;
  appCheckSiteKey: string;
  appCheckDebugMode: boolean;
  appCheckDebugToken: string;
}

const { firestoreDatabaseId, appCheckSiteKey, ...firebase } = firebaseConfigs.dev;

export const firebaseConfig = firebaseConfigs.dev;
export { firestoreDatabaseId };

export const environment: Environment = {
  production: false,
  firebase,
  firestoreDatabaseId,
  apiUrl: 'https://us-central1-dev-danceup.cloudfunctions.net',
  appCheckSiteKey,
  appCheckDebugMode: false,
  appCheckDebugToken: '',
};
